<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 512 96"
    :class="['tp-stars', 'tp-stars--score-'+roundedStars.toString().replace('.','-'), {
      'tp-stars--inline': inline
    }]"
  >

    <g>
      <rect
        y="0"
        x="0"
        width="96"
        height="96"
        class="square"
      />
      <path d="M48,64.7L62.6,61l6.1,18.8L48,64.7z M81.6,40.4H55.9L48,16.2l-7.9,24.2H14.4l20.8,15l-7.9,24.2l20.8-15l12.8-9.2L81.6,40.4L81.6,40.4L81.6,40.4L81.6,40.4z" />
    </g>

    <g>
      <rect
        y="0"
        x="104"
        width="96"
        height="96"
        class="square"
      />

      <rect
        y="0"
        x="152"
        width="48"
        height="96"
        class="rectangle"
      />

      <path d="M152,64.7l14.6-3.7l6.1,18.8L152,64.7z M185.6,40.4h-25.7L152,16.2l-7.9,24.2h-25.7l20.8,15l-7.9,24.2l20.8-15l12.8-9.2L185.6,40.4L185.6,40.4L185.6,40.4L185.6,40.4z" />
    </g>

    <g>
      <rect
        y="0"
        x="208"
        width="96"
        height="96"
        class="square"
      />

      <rect
        y="0"
        x="256"
        width="48"
        height="96"
        class="rectangle"
      />

      <path d="M256,64.7l14.6-3.7l6.1,18.8L256,64.7z M289.6,40.4h-25.7L256,16.2l-7.9,24.2h-25.7l20.8,15l-7.9,24.2l20.8-15l12.8-9.2L289.6,40.4L289.6,40.4L289.6,40.4L289.6,40.4z" />
    </g>

    <g>
      <rect
        y="0"
        x="312"
        width="96"
        height="96"
        class="square"
      />

      <rect
        y="0"
        x="360"
        width="48"
        height="96"
        class="rectangle"
      />

      <path d="M360,64.7l14.6-3.7l6.1,18.8L360,64.7z M393.6,40.4h-25.7L360,16.2l-7.9,24.2h-25.7l20.8,15l-7.9,24.2l20.8-15l12.8-9.2L393.6,40.4L393.6,40.4L393.6,40.4L393.6,40.4z" />
    </g>

    <g>
      <rect
        y="0"
        x="416"
        width="96"
        height="96"
        class="square"
      />

      <rect
        y="0"
        x="464"
        width="48"
        height="96"
        class="rectangle"
      />

      <path d="M464,64.7l14.6-3.7l6.1,18.8L464,64.7z M497.6,40.4h-25.7L464,16.2l-7.9,24.2h-25.7l20.8,15l-7.9,24.2l20.8-15l12.8-9.2L497.6,40.4L497.6,40.4L497.6,40.4L497.6,40.4z" />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'ZgTrustpilotStars',
    props: {
      /**
       * Rating in stars (Numbers 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5) as given by json data (TrustScore.Stars).
       * None valid numbers will be rounded of.
       */
      stars: {
        type: Number,
        required: true,
        validator: value => {
          return !Number.isNaN(Number.parseFloat(value)) && value >= 1.0 && value <= 5.0
        }
      },
      inline: {
        type: Boolean,
        required: false
      }
    },
    computed: {
      roundedStars () {
        return Math.round(this.stars * 2) / 2
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tp-stars {
    height: rhythm(small);

    @include mq(medium) {
      height: calc(#{rhythm(large)} / 2);
    }

    &--inline {
      height: rem(24);
    }

    g .square {
      fill: #dcdce6;
    }

    .rectangle {
      fill: transparent;
    }

    g path {
      fill: #ffffff;
    }

    &--score-1 g:nth-child(-n+1) .square {
      fill: #ff3722;
    }

    &--score-1-5 g:nth-child(-n+2) .square {
      fill: #ff3722;
    }

    &--score-1-5 g:nth-child(2) .rectangle {
      fill: #dcdce6;
    }

    &--score-2 g:nth-child(-n+2) .square {
      fill: #ff8622;
    }

    &--score-2-5 g:nth-child(-n+3) .square {
      fill: #ff8622;
    }

    &--score-2-5 g:nth-child(3) .rectangle {
      fill: #dcdce6;
    }

    &--score-3 g:nth-child(-n+3) .square {
      fill: #ffce00;
    }

    &--score-3-5 g:nth-child(-n+4) .square {
      fill: #ffce00;
    }

    &--score-3-5 g:nth-child(4) .rectangle {
      fill: #dcdce6;
    }

    &--score-4 g:nth-child(-n+4) .square {
      fill: #73cf11;
    }

    &--score-4-5 g:nth-child(-n+5) .square {
      fill: #00b67a;
    }

    &--score-4-5 g:nth-child(5) .rectangle {
      fill: #dcdce6;
    }

    &--score-5 g:nth-child(-n+5) .square {
      fill: #00b67a;
    }
  }
</style>
